import { useUserStore } from "../store/user";
import { createRouter, createWebHistory } from "vue-router";
import MainWrapper from "../views/MainWrapper";

const ACCESS_TOKEN = "app_access_token";

const routes = [
    {
        path: "/",
        component: MainWrapper,
        name: "MainWrapper",
        children: [
            {
                path: "login",
                name: "Login",
                component: () => import("../views/auth/Login.vue"),
                mode: "abstract",
                meta: {
                    title: "Shoptok Business Manager - Login",
                },
            },
            {
                path: "register",
                name: "Register",
                component: () => import("../views/auth/Register.vue"),
                meta: {
                    title: "Shoptok Business Manager - Register",
                },
            },
            {
                path: "forgot-password",
                name: "ForgotPassword",
                component: () => import("../views/auth/ForgotPassword.vue"),
                meta: {
                    title: "Shoptok Business Manager - Forgot Password",
                },
            },
            {
                path: "confirm-reset-password",
                name: "ConfirmResetPassword",
                component: () => import("../views/auth/ConfirmResetPassword.vue"),
            },
            {
                path: "resend-verification-mail",
                name: "ResendVerificationEmail",
                component: () => import("../views/auth/ResendVerificationEmail.vue"),
                meta: {
                    title: "Shoptok Business Manager - Resend Verification Email",
                },
            },
            {
                path: "/dashboard",
                name: "Dashboard",
                component: () => import("../views/dashboard/Dashboard.vue"),
                meta: { requiresAuth: true, title: "Shoptok Business Manager - Dashboard" },
            },
            {
                path: "/growth-formula",
                name: "GrowthFormula",
                component: () => import("../views/growth/GrowthFormula"),
                meta: {
                    requiresAuth: true,
                    notConfirmed: true,
                    title: "Shoptok Business Manager - Growth Formula",
                },
            },
            {
                path: "/trust-ok",
                name: "TrustOk",
                component: () => import("../views/trustOk/TrustOk"),
                meta: {
                    requiresAuth: true,
                    notConfirmed: true,
                    title: "Shoptok Business Manager - Trust Ok",
                },
            },
            {
                path: "/products",
                name: "DashboardProducts",
                component: () => import("../views/dashboard/DashboardProducts"),
                meta: { requiresAuth: true, title: "Shoptok Business Manager - Dashboard Products" },
            },
            {
                path: "/coupons/all",
                name: "CouponsRead",
                component: () => import("../views/coupons/Read"),
                meta: { requiresAuth: true, title: "Shoptok Business Manager - My Coupons" },
            },
            {
                path: "/coupons/add",
                name: "CouponsCreation",
                component: () => import("../views/coupons/Creation"),
                meta: { requiresAuth: true, title: "Shoptok Business Manager - Coupon Creation" },
            },
            {
                path: "/coupons/edit/:id/:shop_id",
                name: "CouponsEdit",
                component: () => import("../views/coupons/Edit"),
                meta: { requiresAuth: true, title: "Shoptok Business Manager - Edit Coupon" },
            },
            {
                path: "/coupons/faq",
                name: "CouponsFaq",
                component: () => import("../views/coupons/Faq"),
                meta: { requiresAuth: true, title: "Shoptok Business Manager - Faq Coupons" },
            },
            {
                path: "/category",
                name: "DashboardCategoryV2",
                component: () => import("../views/dashboard/DashboardCategoryV2"),
                meta: { requiresAuth: true, title: "Shoptok Business Manager - Dashboard Categories" },
            },
            {
                path: "/devices",
                name: "DashboardDevices",
                component: () => import("../views/dashboard/DashboardDevices"),
                meta: { requiresAuth: true, title: "Shoptok Business Manager - Dashboard Devices" },
            },
            {
                path: "/activities",
                name: "DashboardActivities",
                component: () => import("../views/dashboard/DashboardActivities"),
                meta: { requiresAuth: true, title: "Shoptok Business Manager - Dashboard Activities" },
            },
            {
                path: "/liquidity",
                name: "DashboardLiquidity",
                component: () => import("../views/dashboard/DashboardLiquidity"),
                meta: { requiresAuth: true, title: "Shoptok Business Manager - Dashboard Liquidity" },
            },
            {
                path: "/distribution",
                name: "DashboardDistribution",
                component: () => import("../views/dashboard/DashboardDistribution"),
                meta: { requiresAuth: true, title: "Shoptok Business Manager - Dashboard Distribution" },
            },
            {
                path: "/shops",
                name: "Shops",
                component: () => import("../views/Shops.vue"),
                meta: { requiresAuth: true, title: "Shoptok Business Manager - Shops" },
            },
            {
                path: "/price-list",
                name: "PriceList",
                component: () => import("../views/PriceList.vue"),
                meta: { requiresAuth: true, title: "Shoptok Business Manager - Price list" },
            },
            {
                path: "/limit-management",
                name: "LimitManagement",
                component: () => import("../views/LimitManagement.vue"),
                meta: { requiresAuth: true, title: "Shoptok Business Manager - Limit Management" },
            },
            {
                path: "/reports",
                name: "Reports",
                component: () => import("../views/Reports.vue"),
                meta: { requiresAuth: true, title: "Shoptok Business Manager - Reports" },
            },
            {
                path: "/profile",
                name: "Profile",
                component: () => import("../views/Profile.vue"),
                meta: { requiresAuth: true, title: "Shoptok Business Manager - Profile" },
            },
            {
                path: "/bidding",
                name: "Bidding",
                component: () => import("../views/biddingV2/Bidding.vue"),
                meta: { requiresAuth: true, title: "Shoptok Business Manager - Bidding" },
            },
            {
                path: "/bidding/statistics",
                name: "BiddingStatistics",
                component: () => import("../views/biddingV2/BiddingStatistics.vue"),
                meta: { requiresAuth: true, title: "Shoptok Business Manager - Bidding Statistics" },
            },
            {
                path: "/product-ads",
                name: "ProductAd",
                component: () => import("../views/productAd/ProductAd.vue"),
                meta: { requiresAuth: true, title: "Shoptok Business Manager - Product Ads" },
            },
            {
                path: "/product-ad-insights",
                name: "ProductAdInsights",
                component: () => import("../views/productAd/ProductAdInsights.vue"),
                meta: {requiresAuth: true, title: "Shoptok Business Manager - Product Ads Insights"}
            },
            {
                path: "/accessTokens",
                name: "AccessTokens",
                component: () => import("../views/AccessTokens.vue"),
                meta: { requiresAuth: true, title: "Shoptok Business Manager - Access Tokens" },
            },
            {
                path: "/ticket-list",
                name: "TicketList",
                component: () => import("../views/ticketing/TicketList.vue"),
                meta: { requiresAuth: true, title: "Shoptok Business Manager - Ticket List" },
            },
            {
                path: "/ticket-new",
                name: "TicketNew",
                component: () => import("../views/ticketing/TicketNew.vue"),
                meta: { requiresAuth: true, title: "Shoptok Business Manager - Ticket New" },
            },
            {
                path: "/ticket-preview/:ticket_id",
                name: "TicketPreview",
                component: () => import("../views/ticketing/TicketPreview.vue"),
                meta: { requiresAuth: true, title: "Shoptok Business Manager - Ticket Preview" },
            },
            {
                path: "/clicks",
                component: () => import("../views/click/Clicks.vue"),
                meta: { requiresAuth: true, title: "Shoptok Business Manager - Dashboard Click insights" },
                children: [
                    {
                        path: "groups",
                        name: "ClickByGroup",
                        component: () => import("../views/click/ClickByGroup"),
                        meta: { requiresAuth: true },
                    },
                    {
                        path: "models",
                        name: "ClickByModel",
                        component: () => import("../views/click/ClickByModel"),
                        meta: { requiresAuth: true },
                    },
                    {
                        path: "",
                        name: "ClickAnalytics",
                        component: () => import("../views/click/ClickAnalytics"),
                        meta: { requiresAuth: true },
                    },
                ],
            },
            {
                path: "/members",
                name: "Members",
                component: () => import("../views/Members.vue"),
                meta: {
                    requiresAuth: true,
                    requiresAdminRole: true,
                    title: "Shoptok Business Manager - Members",
                },
            },
            {
                path: "/invites",
                name: "Invites",
                component: () => import("../views/Invites.vue"),
                meta: {
                    requiresAuth: true,
                    requiresAdminRole: true,
                    title: "Shoptok Business Manager - Invites",
                },
            },
            {
                path: "/prices",
                component: () => import("../views/product/Prices.vue"),
                meta: { requiresAuth: true, title: "Shoptok Business Manager - Prices" },
                children: [
                    {
                        path: "product-lowest-prices",
                        name: "ProductLowestPrices",
                        component: () => import("../views/product/ProductLowestPrices"),
                        meta: { requiresAuth: true },
                    },
                    {
                        path: "product-expensive-prices",
                        name: "ProductExpensivePrices",
                        component: () => import("../views/product/ProductExpensivePrices"),
                        meta: { requiresAuth: true },
                    },
                    {
                        path: "product-highest-prices",
                        name: "ProductHighestPrices",
                        component: () => import("../views/product/ProductHighestPrices"),
                        meta: { requiresAuth: true },
                    },
                    {
                        path: "",
                        name: "ProductPricesComparison",
                        component: () => import("../views/product/ProductPricesComparison"),
                        meta: { requiresAuth: true },
                    },
                ],
            },
            {
                path: "/module",
                name: "Module",
                component: () => import("../views/module/Module.vue"),
                meta: {
                    requiresAuth: true,
                    requiresAdminRole: true,
                    title: "Shoptok Business Manager - Members",
                },
            },
            {
                path: "/",
                name: "Home",
                component: () => import("../views/Home.vue"),
                meta: { title: "Shoptok Business Manager - Home" },
            },
            {
                path: "/:pathMatch(.*)*",
                name: "NotFound",
                component: () => import("../views/NotFound.vue"),
                meta: { title: "Shoptok Business Manager - Not Found" },
            },
        ],
    },
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
    scrollBehavior(to) {
        return new Promise((resolve) => {
            setTimeout(() => {
                if (to.name === "Home" && to.params.section) {
                    resolve({ el: `#${to.params.section}`, behavior: "smooth" });
                } else {
                    resolve({ top: 0, behavior: "smooth" });
                }
            }, 600);
        });
    },
});

router.beforeEach(async (to) => {
    const userStore = useUserStore();

    if (to.meta.requiresAuth && !localStorage.getItem(ACCESS_TOKEN)) {
        return router.push({ name: "Login" });
    }

    if (to.meta.requiresAuth && !userStore.user) {
        await userStore.fetchUser();
    }

    if (!localStorage.getItem(ACCESS_TOKEN)) {
        if (to.meta.requiresAuth) {
            return router.push({ name: "Login" });
        }
    } else {
        if (to.name === "Login") {
            return router.push({ name: "Dashboard" });
        }
    }

    if (to.meta.requiresAdminRole && userStore.user.role_id === 3) {
        return router.push({ name: "Dashboard" });
    }
});

router.afterEach(async (to) => {
    if (to.meta?.title) {
        document.title = to.meta.title;
    } else {
        document.title = "Shoptok Business Manager";
    }
});

export default router;
